module.exports = __webpack_public_path__ + "static/trips-0cf970ed08c5b89f89b7e7299bed8308.png";